import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { projectVisited } from 'core/features/projects/projectsSlice';

/**
 * Klickbarer Kreis für ein einzelnes Projekt auf der Übersichtsseite.
 *
 * @param {{ project: import('types/dto').ProjectDTO, highlighted?: boolean }} props
 */
export default function ProjectCircle({ project, highlighted = false }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const isActive = project.status === 'active';

  const handleOpen = () => {
    if (!isActive) return;
    dispatch(projectVisited(project.id));
    navigate(project.path);
  };

  return (
    <div className="flex flex-col items-center gap-3 text-center">
      <button
        type="button"
        onClick={handleOpen}
        disabled={!isActive}
        aria-label={`Projekt ${project.name} öffnen`}
        className={[
          'group relative flex h-36 w-36 items-center justify-center rounded-full',
          'bg-gradient-to-br shadow-lg ring-1 ring-ink/10 transition-all duration-300',
          project.gradient,
          isActive
            ? 'cursor-pointer hover:scale-105 hover:shadow-2xl hover:ring-ink/20 focus:outline-none focus:ring-4 focus:ring-ink/25'
            : 'cursor-not-allowed opacity-40 grayscale',
          highlighted ? 'ring-4 ring-ink/30' : '',
        ].join(' ')}
      >
        <span className="text-5xl drop-shadow-sm transition-transform duration-300 group-hover:scale-110">
          {project.icon}
        </span>

        {project.status === 'coming-soon' && (
          <span className="absolute -bottom-2 rounded-full bg-ink px-2 py-0.5 font-mono text-[10px] font-medium uppercase tracking-wide text-paper">
            bald
          </span>
        )}
      </button>

      <div>
        <p className="font-serif text-lg font-semibold text-ink">{project.name}</p>
        <p className="mx-auto mt-1 max-w-[12rem] text-xs leading-snug text-ink-muted">
          {project.description}
        </p>
      </div>
    </div>
  );
}
